export const NavBarLinks = [
    {
        id : "home",
        title : "Home",
        titleLink : "epfl/home",
        subsection: [{section: "Home", url:"epfl/home"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/homelogo.png",
    },
    {
        id : "people",
        title: "People",
        titleLink : "epfl/team",
        subsection : [{section:"Team", url:"epfl/team"}, {section:"Attributions", url:"epfl/attributions"},{section:"Acknowledgements", url:"epfl/acknowledgements"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/teamlogo.png",
    },
    {
        id : "project",
        title: "Project",
        titleLink: "epfl/description",
        subsection : [{section:"Contribution", url: "epfl/contribution"}, {section:"Description", url:"epfl/description"}, 
        {section:"Engineering", url:"epfl/engineering"}, {section:"Experiments", url:"epfl/experiments"}, 
        {section:"Notebook", url:"epfl/notebook"}, {section:"Results", url:"epfl/results"}, {section:"Parts",title : "Parts", url:"epfl/parts"}
        ,{section:"Protocols", url:"epfl/protocols"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/projectlogo.png",
    },
    {
        id : "safety",
        title : "Safety",
        titleLink : "epfl/safety",
        subsection : [{section:"Safety", url:"epfl/safety"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/safetylogo.png",
    },
    {
        id : "HumanPractices",
        title : "Human Practices",
        titleLink : "epfl/human-practices",
        subsection : [{section:"Human Practices", url:"epfl/human-practices"},{section:"Events and Collabs", url:"epfl/events"}, {section:"Product", url:"epfl/product-page"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/humanpracticeslogo.png",

    },
    {
        id : "education",
        title : "Education",
        titleLink : "epfl/education",
        subsection: [{ section: "Education", url: "epfl/education" }, { section: "BSGV", title: "BSGV", url:"epfl/BSGV"}, { section: "Game", title: "Game", url:"epfl/game"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/educationlogo.png",

    },
    {
        id : "awards",
        title : "Awards",
        titleLink : "epfl/awards",
        subsection : [{section:"Awards", url:"epfl/awards"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/awardlogo.png",

    },

]
export const NavBarLinksKids = [
    {
        id : "home",
        title : "Home",
        titleLink : "epfl/home",
        subsection: [{section: "Home", url:"epfl/home"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/homelogo.png",
    },
    {
        id : "project",
        title: "Project",
        titleLink : "epfl/user-friendly/description",
        subsection : [{section:"Description", url:"epfl/user-friendly/description"}, 
        {section:"Engineering", url:"epfl/user-friendly/engineering"}, {section:"Experiments", url:"epfl/user-friendly/experiments"}, 
         {section:"Results", url:"epfl/user-friendly/results"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/projectlogo.png",
    },

    {
        id : "game",
        title : "Game",
        titleLink : "epfl/game",
        subsection : [{section:"Game", url:"epfl/game"}],
        logo: "https://static.igem.wiki/teams/4888/wiki/humanpracticeslogo.png",

    }
]